module.exports = function(x) {
  return (x * x * x * (35 / 3072));
};